/**
 * Vertex360 Copilot — Python AI service client (SSE streaming).
 */
import { aiClient, aiStreamPost } from "./aiClient";
import {
  URL_AI_VERTEX360_COPILOT_CHAT_STREAM,
  URL_AI_VERTEX360_COPILOT_FEEDBACK,
} from "./URL";

export const vertex360CopilotApi = {
  /**
   * Thumbs feedback for promote-board (does not affect credits).
   * Persisted per assistant message — ``messageId`` is required.
   * @param {{ rating: 'up'|'down', messageId: number|string, conversationId?: string, note?: string }} payload
   */
  sendFeedback(payload = {}) {
    const rating = String(payload.rating || "").toLowerCase();
    const messageId =
      payload.messageId != null && /^\d+$/.test(String(payload.messageId))
        ? Number(payload.messageId)
        : null;
    if (!messageId) {
      return Promise.reject(new Error("message_id is required for feedback"));
    }
    return aiClient.post(URL_AI_VERTEX360_COPILOT_FEEDBACK, {
      rating,
      message_id: messageId,
      ...(payload.conversationId
        ? { conversation_id: payload.conversationId }
        : {}),
      ...(payload.note ? { note: String(payload.note).slice(0, 500) } : {}),
    });
  },

  /**
   * Streamed copilot chat (SSE).
   * POST /api/v1/vertex360-copilot/chat/stream
   *
   * Body is message + conversation_id + clarify fields + clear_active_filters only.
   * Never send UI `module` tabs or browser `pathname`.
   *
   * @param {string} text
   * @param {{ onEvent?: Function, signal?: AbortSignal, conversationId?: string, clarifyMessageId?: string|number, clarifySelectedOption?: string, clarifySelectedLabel?: string, clarifyAnswers?: object, clearActiveFilters?: boolean }} [options]
   */
  sendMessageStream(text, options = {}) {
    const {
      conversationId,
      clarifyMessageId,
      clarifySelectedOption,
      clarifySelectedLabel,
      clarifyAnswers,
      clearActiveFilters,
      ...streamOptions
    } = options;
    const hasClarify =
      clarifyMessageId != null &&
      /^\d+$/.test(String(clarifyMessageId)) &&
      (Boolean(clarifySelectedOption) ||
        (clarifyAnswers && typeof clarifyAnswers === "object"));

    return aiStreamPost(
      URL_AI_VERTEX360_COPILOT_CHAT_STREAM,
      {
        message: text,
        ...(conversationId ? { conversation_id: conversationId } : {}),
        ...(clearActiveFilters ? { clear_active_filters: true } : {}),
        ...(hasClarify
          ? {
              clarify_message_id: Number(clarifyMessageId),
              ...(clarifySelectedOption
                ? { clarify_selected_option: clarifySelectedOption }
                : { clarify_selected_option: "__typed__" }),
              ...(clarifySelectedLabel
                ? { clarify_selected_label: clarifySelectedLabel }
                : {}),
              ...(clarifyAnswers && typeof clarifyAnswers === "object"
                ? { clarify_answers: clarifyAnswers }
                : {}),
            }
          : {}),
      },
      streamOptions
    );
  },
};
